import { faChevronRight, faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { colours } from '../../assets/colours';
import smileyFace from '../images/smileyFace.png';

type InviteLeftMenuProps = {
  userFnF: any[];
  activeProfile: any;
  handleActiveProfile: (index: number) => void;
};

export function InviteLeftMenu({
  userFnF,
  activeProfile,
  handleActiveProfile,
}: InviteLeftMenuProps) {
  const { t } = useTranslation();
  return (
    <fieldset>
      <legend className="profile-name left">{t('I001')}</legend>
      <div role="radiogroup" aria-label={t('I001')}>
        {Array.from({ length: 3 }).map((_, index) =>
          index < userFnF?.length ? (
            <ActiveProfile
              key={index}
              userFnF={userFnF}
              index={index}
              activeProfile={activeProfile}
              handleActiveProfile={handleActiveProfile}
            />
          ) : (
            <InviteOption
              key={index}
              index={index}
              handleActiveProfile={() => handleActiveProfile(index)}
            />
          )
        )}
      </div>
    </fieldset>
  );
}

function ActiveProfile({ userFnF, index, activeProfile, handleActiveProfile }) {
  const { t } = useTranslation();

  const isPending = userFnF?.[index]?.status === 'pending';

  return (
    <label
      className={`profile-slider-btn large ${
        index === activeProfile.id ? 'active' : ''
      } fs-exclude`}
      htmlFor={`profile-radio-${index}`}
    >
      <input
        type="radio"
        id={`profile-radio-${index}`}
        name="profile-selection"
        value={index}
        checked={index === activeProfile.id}
        onChange={() => handleActiveProfile(index)}
        className="visuallyHidden"
        aria-label={`${userFnF?.[index]?.name} - ${isPending ? t('S015') : t('S138')}`}
      />
      <div className="menu-item" aria-hidden="true">
        <div
          className="ff-cont"
          style={{
            backgroundColor: colours[userFnF?.[index]?.colour],
          }}
        >
          <img src={smileyFace} alt="smiley face" />
        </div>
        <div className="text-cont">
          <div className="slider-text">
            {userFnF?.[index]?.name}
            <span hidden>{`${t('S137')}: ${isPending ? t('S015') : t('S138')}`}</span>
          </div>
          {isPending && (
            <div className="pending" tabIndex={-1}>
              {t('S015')}
            </div>
          )}
        </div>
      </div>
      <FontAwesomeIcon icon={faChevronRight} className="slider-chevron" aria-hidden="true" />
    </label>
  );
}

function InviteOption({ handleActiveProfile, index }) {
  const { t } = useTranslation();
  return (
    <label className="profile-slider-btn large empty" htmlFor={`invite-radio-${index}`}>
      <input
        type="radio"
        id={`invite-radio-${index}`}
        name="profile-selection"
        value={index}
        onChange={handleActiveProfile}
        className="visuallyHidden"
        aria-label={`${t('S013')} - ${t('S139')}`}
      />
      <div className="menu-item" aria-hidden="true">
        <div className="ff-cont ">
          <img src={smileyFace} alt="smiley face" />
        </div>
        <div className="text-cont">
          <div className="slider-text">
            {t('S013')}
            <span className="visuallyHidden">{t('S139')}</span>
          </div>
        </div>
      </div>
      <FontAwesomeIcon icon={faPlusCircle} className="slider-chevron" aria-hidden="true" />
    </label>
  );
}
